import React, { useState, useEffect, useCallback, useRef } from 'react';
import Logo from "../images/logo.svg";
import Select from 'react-select';
import Sidebar from '../component/Sidebar';
import { SelectPicker, Placeholder, Button, Whisper, Tooltip } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { useParams ,Link, useNavigate } from "react-router-dom";
import iconReportUsers from "../images/iconReportUsers.svg";
import 'aos/dist/aos.css';
import AOS from 'aos';
import imgBack from "../images/icon-back.svg";
import debounce from 'lodash.debounce';
import { ChakraProvider, useToast, Wrap } from '@chakra-ui/react'

function ComplianceProfileReports() {
  const apiEndPoint = process.env.REACT_APP_API_ESG_ENDPOINT;
  const [tabName, setTabName] = useState('ISRI Compliance Profile Reports');
  const [isLoading, setLoading] = useState(true); // State to manage loading state
  const { company_symbol } = useParams();
  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

  useEffect(() => {
    AOS.init();
  }, []);

  const abortControllerRefGlobal = useRef(null);
  const cancelButtonRef = useRef(null);

  const toast = useToast()
const toastIdRef = React.useRef()


  const navigate = useNavigate();
  const [reportData, setReportData] = useState([]);
  const [reportCount, setReportCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [startPage, setStartPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [complianceId, setComplianceId] = useState("");
  const [statusId, setStatusId] = useState("");

  const [copiedText, setCopiedText] = useState(null);
  const [searchInput, setSearchInput] = useState("");

  const [countryData, setCountryData] = useState([]);
  const [complianceData, setComplianceData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const userid = localStorage.getItem("novauserid");
  const [pageRange, setPageRange] = useState("20");



  const [customPaginationValue, setCustomPaginationValue] = useState("");
  const PagingData = ['10', '20', '50', '100'].map(
item => ({ label: item, value: item })
);

  //Country List
  useEffect(() => {
    const fetchCountryList = async () => {
      const url = `${apiEndPoint}/get_country_list`;
      const payload = {
        data: {
          user_id: userid // Replace with the actual user_id if dynamic
        }
      };
  
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
  
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
  
        const responseData = await response.json();
        const data = responseData.data; // Flatten the response

        const formattedCountryData = data.data.map((country) => ({
          label: country.country_name,
          value: country.country_code,
        }));

        setCountryData(formattedCountryData);
  
      } catch (error) {
        console.log(error);
      }
    };
  
    fetchCountryList();
  }, []);

  // Compliance List
  useEffect(() => {
    const fetchComplianceStatusList = async () => {
      const url = `${apiEndPoint}/get_compliance_status`;
      const payload = {
        data: {
          user_id: userid // Replace with the actual user_id if dynamic
        }
      };
  
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
  
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
  
        const responseData = await response.json();
        const data = responseData.data; // Flatten the response

        const formattedComplianceStatusData = data.data.map((complaince) => ({
          label: complaince.name,
          value: complaince.id,
        }));

        setComplianceData(formattedComplianceStatusData);
  
      } catch (error) {
        console.log(error);
      }
    };
  
    fetchComplianceStatusList();
  }, []);

  //Status List
  useEffect(() => {
    const fetchStatusList = async () => {
      const url = `${apiEndPoint}/get_status`;
      const payload = {
        data: {
          user_id: userid // Replace with the actual user_id if dynamic
        }
      };
  
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
  
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
  
        const responseData = await response.json();
        const data = responseData.data; // Flatten the response

        const formattedStatusData = data.data.map((status) => ({
          label: status.name,
          value: status.id,
        }));

        setStatusData(formattedStatusData);
  
      } catch (error) {
        console.log(error);
      }
    };
  
    fetchStatusList();
  }, []);

  //

   const fetchGlobalReport = async () => {
  
      setLoading(true);
  
      // Cancel the previous request if any
      if (abortControllerRefGlobal.current) {
        abortControllerRefGlobal.current.abort();
      }
  
       // Create a new AbortController for the current request
       const controller = new AbortController();
       abortControllerRefGlobal.current = controller;
  
  
      try {
      
        const apiUrl = `${apiEndPoint}/iri_report_history`;
        const requestData = {
          data: {
            user_id: userid,
            limit: pageRange,
            page: currentPage.toString(),
            company_symbol:company_symbol,
          }

        };
  
        //console.log(JSON.stringify(requestData));
  
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestData),
          signal: controller.signal
        });
        
        const jsonData = await response.json();
        if (jsonData.data.status === "success") {
          setLoading(false);
          setReportCount(jsonData.data.count);
          setReportData(jsonData.data.data);
        } else {
          setLoading(false);
          toastIdRef.current = toast({ description: jsonData.data.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
          return false;
        }
      } catch (error) {
        if (error.name === "AbortError") {
          console.log("GLobal Request cancelled");
        }
        else{
        setLoading(false);
        toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
      }
        return false;
      }
    };

  useEffect(() => {
    fetchGlobalReport();
  }, [currentPage, searchQuery, countryCode, searchInput,complianceId,statusId]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (page >= startPage + 5) {
      setStartPage(page - 4);
    } else if (page < startPage) {
      setStartPage(page);
    }
  };

  const totalPages = Math.ceil(reportCount / 20);
  const endPage = Math.min(startPage + 4, totalPages);

  const data = ['India', 'United States', 'Australia'].map(
    item => ({ label: item, value: item })
  );

  const data2 = ['Quarter', 'Second Quarter', 'Third Quarter'].map(
    item => ({ label: item, value: item })
  );

  const [copied, setCopied] = useState(false);

  const copyText = (text) => {
  if (text !== copiedText) {
    const tempTextArea = document.createElement('textarea');
    tempTextArea.value = text;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand('copy');
    document.body.removeChild(tempTextArea);
    setCopiedText(text);
    setTimeout(() => {
      setCopiedText(null);
    }, 2000);
  }
};


 //Table Loader 
 
//  useEffect(() => {
//      // Simulate an API call or data loading delay
//      setTimeout(() => setLoading(false), 2000); // Simulate 2 seconds loading time
//    }, []);



const handleSearch = (event) => {
  setSearchInput(event.target.value);
  const inputValue = event.target.value;
  //if (inputValue.length >= 3) {
  setCurrentPage(1); // Reset to the first page for new search
  setSearchQuery(inputValue);
  //}
};


const handleCountryChange = (value) => {
  setCountryCode(value);
};

const handleComplianceChange = (value) => {
  setComplianceId(value);
};

const handleStatusChange = (value) => {
  setStatusId(value);
};


const handleComplianceReport = (encryptJSON) => {
  navigate(`/ComplianceMerlineView/${encryptJSON}`);
};


const handleBack = async () => {
  navigate("/compliance-reports");
};

 function getIriScoreClass(score) {
  if (score >= 0 && score < 1) return 'status__task__poor';
  if (score >= 1 && score < 2) return 'status__task__weak';
  if (score >= 2 && score < 3) return 'status__task__fair';
  if (score >= 3 && score < 4) return 'status__task__good';
  if (score >= 4 && score <= 5) return 'status__task__exc';
  return ''; // fallback if out of range
}

// Debounced function to update the page number
const debouncedSetPage = useCallback(
  debounce((page) => {
    setCurrentPage(page);
  }, 500), // Delay of 500ms (half a second)
  []
);


const handlePaginationChange = (e) => {
  const value = (e.target.value == 0 ? 1 : e.target.value).toString() ;
  setCustomPaginationValue(value); // Update input value immediately for fast typing
  debouncedSetPage(Number(value)); // Trigger the debounced function
};

const handlePagelimit = (value) => {
  setCurrentPage(1);
  setCustomPaginationValue(1);
  setPageRange(value); 
};

const renderPagination = () => {
  // Calculate total number of pages
  const totalPages = Math.ceil(reportCount / pageRange);

  // Show a default of 3 pages if the total pages are more than 3
  const pageNumbers = [];
  const visiblePageCount = 4; // Number of pages to show by default

  let startPage = currentPage - 1;
  let endPage = currentPage + 2;

  // Adjust pagination if total pages are less than the default
  if (totalPages <= visiblePageCount) {
    startPage = 1;
    endPage = totalPages;
    
  } else {
    
    // Ensure the pagination does not go out of bounds
    startPage = Math.max(1, startPage);
    endPage = Math.min(totalPages, endPage);
  }

  // Create page numbers to display based on current page
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <nav aria-label="..." id='pagination_row' style={{alignItems:'center', justifyContent:'space-between', background:'#FFF', paddingTop:0, paddingBottom:0}}>
      <div className='totalRecords'>
        Total Records :  {Number(reportCount).toLocaleString()}
      </div>
      <ul className="pagination" style={{border: 0, background: 'none'}}>

      <li class="page-item" style={{marginLeft:10}}>
                    <SelectPicker onChange={handlePagelimit} cleanable={false}
                    value={pageRange} 
                    placement="top" placeholder='Pages' data={PagingData} searchable={false} style={{ width: 85, height:35, display:'flex', alignItems:'center', borderRadius: 5, border: '1px solid #A1B9ED'}} />
                  </li>

        {/* Previous Page (Double Arrow) */}
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`} style={{marginLeft: 10}}>
          <a href="#" className="page-link" onClick={() => setCurrentPage(1)}>
            <i className="fa fa-angle-double-left"></i>
          </a>
        </li>

        {/* Previous Page (Single Arrow) */}
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <a href="#" className="page-link" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}>
            <i className="fa fa-angle-left"></i>
          </a>
        </li>

        {/* Page numbers */}
        {pageNumbers.map(page => (
          <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
            <a 
              className="page-link" href="#" 
              onClick={() => setCurrentPage(page)} // Set the clicked page as the current page
            >
              {page}
            </a>
          </li>
        ))}
        
        {/* Next Page (Single Arrow) */}
        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <a href="#" className="page-link" onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}>
            <i className="fa fa-angle-right"></i>
          </a>
        </li>

        {/* Next Page (Double Arrow) */}
        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`} style={{marginRight: 10}}>
          <a href="#" className="page-link" onClick={() => setCurrentPage(totalPages)}>
            <i className="fa fa-angle-double-right"></i>
          </a>
        </li>
        
        {/* Go to Page */}
        <li className="page-item" style={{marginLeft: 10, display: 'flex', alignItems: 'center', gap: 5}}>
          <input
            type="text"
            placeholder="Go#"
            className="form-control"
            value={customPaginationValue}
            onChange={handlePaginationChange}
            onInput={(e) => {
              // Only allow numbers
              e.target.value = e.target.value.replace(/[^0-9]/g, '');
            }}
          
            style={{
              padding: '0px 10px', 
              color: '#878787', 
              fontSize: 16, 
              borderRadius: 5, 
              border: '1px solid #A1B9ED', 
              width: 60, 
              height: 35, 
              textAlign: 'center'
            }}
          />
        </li>
      </ul>
    </nav>
  );
};

  return (
    <>
      <Sidebar />
      <ChakraProvider resetCSS={false}></ChakraProvider>
      <div id='header'>
        <div className='logo'>
           {/* <Button className='btn_Back_head' onClick={handleBack}><img src={imgBack}/></Button> */}
            <div className='logo_icon'>
                <img src={Logo} />
            </div>
            <div className='brand_name'>{companyName}</div>
        </div>
    </div>
      <div className="container-fluid content pb-5">
        <div className='company_table_list' data-aos="fade-up" data-aos-duration="600">
        {isLoading && ( <Placeholder.Grid rows={20} columns={9} active style={{paddingLeft:20, paddingRight:20, paddingTop:12}} /> )}

{/* Table */}
{!isLoading && (
<>
       <div className='table-responsive clsPagingWrap' >
                   <table className='table'>
                     <thead>
                       <tr>
                         <th>Ticker and Stock Name</th>
                         <Whisper placement="top" controlId="control-id-hover" trigger="hover"  speaker={<Tooltip>Combined Country and Exchange information</Tooltip>}> 
                         <th style={{cursor:'pointer'}}>Country</th>
                         </Whisper>
                         <th style={{textAlign:'right'}}>Score</th>
                         <th>Report No</th>
                         <th>Analyst</th>
                         <th>Publish Date</th>
                         <th>Publish By</th>
                       
                       
                       </tr>
                     </thead>
                     <tbody>
                     {reportData.length > 0 ? (
         reportData.map((company, index) => (
                         <tr key={index}>
                           <td>
                             <div className='company_name_td'>
                               <span className='company_lable' style={{width:115}}>{company.company_symbol}</span>
                               <div className="clogo">
                           <img src={company.logo} />
                         </div>
                               {company.name}
                             </div>
                           </td>
                           <td>{company.country} - {company.exchange_symbol}</td>
                        
                           <td >
                             <div className="status__task__row" style={{background:'none', justifyContent:'flex-end'}}>
                                 <span className="status__task__text">{company.score_classification}</span>
                                 <span className={`status__task ${getIriScoreClass(company.iri_score)}`}>{company.iri_score}</span>
                             </div>          
                           </td>
                         <td>
                           {'R'+company.report_no}
                           </td>
                           <td>
                           {company.analyst_name}
                           </td>
                           <td>{company.publish_date}</td>     
                           <td>{company.published_by}</td>     
                             
                         </tr>
       
       
       
                       ))
                     ) : (
                       <tr>
                         <td colSpan="9" style={{ textAlign: "center" }}>
                           No data available
                         </td>
                       </tr>
                     )}
                     </tbody>
                   </table>
                 </div>
       
                 {reportCount > 0 && renderPagination()}
        </>    
)}
        </div>
      </div>

      {/* Modal */}
      <div className="modal fade duplicate_form_modal" id="CreateReportModal" tabIndex="-1" aria-labelledby="DuplicateFormModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5">Igene Biotechnology Inc</h1>
            </div>
            <div className="modal-body">
              <div className='duplicate_form_content'>
                <div className='duplicate_form_row'>
                  <div className='duplicate_form_col'>
                    <label>Report Source</label>
                    <input type='text' className='form-control' placeholder='YYYY' />
                  </div>

                  <div className='duplicate_form_col'>
                    <label>Filling Type</label>
                    <div className='select_drop_picker'>
                      <SelectPicker
                        data={data2}
                        searchable={false}
                        style={{ width: '100%' }}
                        placeholder="Quarter"
                      />
                    </div>
                  </div>
                </div>

                <div className="btn__group">
                  <button type="button" className="btn_cancel" data-bs-dismiss="modal">Cancel</button>
                  <button type="button" className="btn_duplicate btn_add_new_report">Add New Report</button>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default ComplianceProfileReports;
